const c = {
  name: "Users9",
  dimensions: { width: 38, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 38 40" style="enable-background:new 0 0 38 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M7,0C5.3,0,4,1.3,4,3c0,1.7,1.3,3,3,3c1.7,0,3-1.3,3-3C10,1.3,8.7,0,7,0z M6,3c0-0.6,0.4-1,1-1
			c0.6,0,1,0.4,1,1c0,0.6-0.4,1-1,1C6.4,4,6,3.6,6,3z"/>
		<path class="st0" d="M5,7c-2.8,0-5,2.2-5,5v4h2v-4c0-1.7,1.3-3,3-3h4c1.7,0,3,1.3,3,3v4h2v-4c0-1.7,1.3-3,3-3h4c1.7,0,3,1.3,3,3v4
			h2v-4c0-1.7,1.3-3,3-3h4c1.7,0,3,1.3,3,3v4h2v-4c0-2.8-2.2-5-5-5h-4c-1.6,0-3.1,0.8-4,2c-0.9-1.2-2.4-2-4-2h-4c-1.6,0-3.1,0.8-4,2
			c-0.9-1.2-2.4-2-4-2H5z"/>
		<path class="st0" d="M16,3c0-1.7,1.3-3,3-3c1.7,0,3,1.3,3,3c0,1.7-1.3,3-3,3C17.3,6,16,4.7,16,3z M19,2c-0.6,0-1,0.4-1,1
			c0,0.6,0.4,1,1,1c0.6,0,1-0.4,1-1C20,2.4,19.6,2,19,2z"/>
		<path class="st0" d="M28,3c0-1.7,1.3-3,3-3c1.7,0,3,1.3,3,3c0,1.7-1.3,3-3,3C29.3,6,28,4.7,28,3z M31,2c-0.6,0-1,0.4-1,1
			c0,0.6,0.4,1,1,1c0.6,0,1-0.4,1-1C32,2.4,31.6,2,31,2z"/>
		<path class="st0" d="M4,15c0-1.7,1.3-3,3-3c1.7,0,3,1.3,3,3c0,1.7-1.3,3-3,3C5.3,18,4,16.7,4,15z M7,14c-0.6,0-1,0.4-1,1
			c0,0.6,0.4,1,1,1c0.6,0,1-0.4,1-1C8,14.4,7.6,14,7,14z"/>
		<path class="st0" d="M5,19c-2.8,0-5,2.2-5,5v4h2v-4c0-1.7,1.3-3,3-3h4c1.7,0,3,1.3,3,3v4h2v-4c0-1.7,1.3-3,3-3h4c1.7,0,3,1.3,3,3
			v4h2v-4c0-1.7,1.3-3,3-3h4c1.7,0,3,1.3,3,3v4h2v-4c0-2.8-2.2-5-5-5h-4c-1.6,0-3.1,0.8-4,2c-0.9-1.2-2.4-2-4-2h-4
			c-1.6,0-3.1,0.8-4,2c-0.9-1.2-2.4-2-4-2H5z"/>
		<path class="st0" d="M16,15c0-1.7,1.3-3,3-3c1.7,0,3,1.3,3,3c0,1.7-1.3,3-3,3C17.3,18,16,16.7,16,15z M19,14c-0.6,0-1,0.4-1,1
			c0,0.6,0.4,1,1,1c0.6,0,1-0.4,1-1C20,14.4,19.6,14,19,14z"/>
		<path class="st0" d="M28,15c0-1.7,1.3-3,3-3c1.7,0,3,1.3,3,3c0,1.7-1.3,3-3,3C29.3,18,28,16.7,28,15z M31,14c-0.6,0-1,0.4-1,1
			c0,0.6,0.4,1,1,1c0.6,0,1-0.4,1-1C32,14.4,31.6,14,31,14z"/>
		<path class="st0" d="M4,27c0-1.7,1.3-3,3-3c1.7,0,3,1.3,3,3c0,1.7-1.3,3-3,3C5.3,30,4,28.7,4,27z M7,26c-0.6,0-1,0.4-1,1
			c0,0.6,0.4,1,1,1c0.6,0,1-0.4,1-1C8,26.4,7.6,26,7,26z"/>
		<path class="st0" d="M5,31c-2.8,0-5,2.2-5,5v4h2v-4c0-1.7,1.3-3,3-3h4c1.7,0,3,1.3,3,3v4h2v-4c0-1.7,1.3-3,3-3h4c1.7,0,3,1.3,3,3
			v4h2v-4c0-1.7,1.3-3,3-3h4c1.7,0,3,1.3,3,3v4h2v-4c0-2.8-2.2-5-5-5h-4c-1.6,0-3.1,0.8-4,2c-0.9-1.2-2.4-2-4-2h-4
			c-1.6,0-3.1,0.8-4,2c-0.9-1.2-2.4-2-4-2H5z"/>
		<path class="st0" d="M16,27c0-1.7,1.3-3,3-3c1.7,0,3,1.3,3,3c0,1.7-1.3,3-3,3C17.3,30,16,28.7,16,27z M19,26c-0.6,0-1,0.4-1,1
			c0,0.6,0.4,1,1,1c0.6,0,1-0.4,1-1C20,26.4,19.6,26,19,26z"/>
		<path class="st0" d="M28,27c0-1.7,1.3-3,3-3c1.7,0,3,1.3,3,3c0,1.7-1.3,3-3,3C29.3,30,28,28.7,28,27z M31,26c-0.6,0-1,0.4-1,1
			c0,0.6,0.4,1,1,1c0.6,0,1-0.4,1-1C32,26.4,31.6,26,31,26z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as Users9
};
